export var cardBody = {
    defaultProps: {
        className: ""
    },
    styles: {
        base: {
            p: "p-6"
        }
    }
};
export default cardBody;
